import { getAuthHeaders } from './auth';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getPrivacySettings = async () => {
  const response = await fetch(`${API_URL}/api/privacy/settings`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    throw new Error('Failed to get privacy settings');
  }
  
  return response.json();
};

export const updatePrivacySettings = async (settings) => {
  const response = await fetch(`${API_URL}/api/privacy/settings`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(settings)
  });
  
  if (!response.ok) {
    throw new Error('Failed to update privacy settings');
  }
  
  return response.json();
};
